<template>
  <div>
    <loading-container v-if="loading"></loading-container>

    <div v-else>
      <headline-container headline="Capacity" :breadcrumbs="breadcrumbs">
        <select-widget
            style="margin-top: 12px;"
            :value="channel"
            :options="channelOptions"
            placeholder="Select Channel..."
            @input="setChannel"
        ></select-widget>
      </headline-container>

      <div class="container">
        <div v-if="!channel" class="panel panel-default">
          <div class="panel-body text-center" style="padding: 50px;">
            <i class=" fa fa-search" style="font-size: 96px;"></i>

            <br><br>

            Select a channel to display the capacity.
          </div>
        </div>

        <time-based-channel-capacity-panel
            v-if="channelType === 'time-based-channels'"
            :channel-id="channelId"
            :channel-type="channelType"
        ></time-based-channel-capacity-panel>

        <publication-based-channel-capacity-panel
            v-if="channelType === 'publication-based-channels'"
            :channel-id="channelId"
            :channel-type="channelType"
        ></publication-based-channel-capacity-panel>
      </div>
    </div>
  </div>
</template>

<script>
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import Load from '@/mixins/Load'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import PublicationBasedChannelCapacityPanel from '@/components/Panels/Publications/PublicationBasedChannelCapacityPanel'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import TimeBasedChannelCapacityPanel from '@/components/Panels/Publications/TimeBasedChannelCapacityPanel'

export default {
  components: {
    HeadlineContainer,
    LoadingContainer,
    PublicationBasedChannelCapacityPanel,
    SelectWidget,
    TimeBasedChannelCapacityPanel
  },

  mixins: [Load],

  data() {
    return {
      channelType: this.getQueryParam('channel-type'),
      channelId: parseInt(this.getQueryParam('channel-id')),
      channels: null
    }
  },

  mounted() {
    this.load({channels: '/api/v1/channels'})
  },

  computed: {
    breadcrumbs() {
      return [
        {text: 'Capacity'}
      ]
    },

    channel() {
      if (this.channelType && this.channelId) {
        return JSON.stringify({id: this.channelId, type: this.channelType})
      }
    },

    channelOptions() {
      let channels = this.channels.data.map(channel => {
        return {
          value: JSON.stringify({id: channel.id, type: channel.type}),
          label: channel.name + ' (' + channel.portal.name + ')'
        }
      })

      channels.sort((a, b) => a.label < b.label ? -1 : 1)

      return channels
    }
  },

  methods: {
    setChannel(value) {
      this.channelId = JSON.parse(value).id

      this.channelType = JSON.parse(value).type

      this.$router.push(
          '/capacity?channel-id=' + JSON.parse(value).id + '&channel-type=' + JSON.parse(value).type
      )
    },

    getQueryParam(key, defaultValue = null) {
      return typeof this.$route.query[key] !== 'undefined' ? this.$route.query[key] : defaultValue
    }
  }
}
</script>
